import React from "react";
import ReactDOM from "react-dom";
import { Principal } from "./routes/PrincipalRouter";
import TagManager from 'react-gtm-module';
 
const tagManagerArgs = {
    //gtmId: 'GTM-TGN2WQV'
    gtmId: process.env.REACT_APP_MODE === 'prod' ? 'GTM-5LQGFZJ' : 'GTM-NRC4V5M'
    
};
 
TagManager.initialize(tagManagerArgs);

ReactDOM.render(<Principal />, document.getElementById("root"));
